module.exports = __webpack_public_path__ + "static/media/ice-hockey.9cd34b05.svg";